export const MENUS = {
  "freidaNavigation":[
      [
        { "title":"Explore Specialties",
          "url":"/specialty",
          "children":[]
        },
        { "title":"Tools & Resources",
          "url":"route:<nolink>",
          "children":[
            { "title":"Video Gallery","url":"/video-series" },
            { "title":"Prep for Residency","url":"/road-to-residency-guide" },
            { "title":"Residency Calculator","url":"/calculator" },
            { "title":"OBGYN ACI","url":"/residency-alignment?retake=true" },
            { "title":"Contact FREIDA","url":"/contact" },
            { "title":"FAQ","url":"/faq" }
          ]
        },
        { "title":"Vacant Positions",
          "url":"/vacant-position/list",
          "children":[]
        },
        { "title":"Institution Directory",
          "url":"/institution",
          "children":[]
        },
        { "title":"Program Director Portal",
          "url":"/director",
          "children":[]
        }
      ]
    ],
    "globalExplore": [
       { "title":"CME from AMA Ed Hub™",
      "url":"https://edhub.ama-assn.org/pages/find-cme-keep-current",
      "children":[] },
    { "title":"AMA Physician Profiles",
      "url":"https://commerce.ama-assn.org/amaprofiles/",
      "children":[] },
    { "title":"CPT®",
      "url":"https://www.ama-assn.org/practice-management/cpt",
      "children":[] },
    { "title":"JAMA Network™",
      "url":"https://jamanetwork.com/",
      "children":[] },
    { "title":"AMA Journal of Ethics®",
      "url":"https://journalofethics.ama-assn.org/home",
      "children":[]
    },
    { "title":"Code of Medical Ethics",
      "url":"https://code-medical-ethics.ama-assn.org/",
      "children":[]
    },
    { "title":"Store",
      "url":"https://www.ama-assn.org/practice-management/ama-store",
      "children":[]
    },
    { "title":"AMA Guides®",
      "url":"https://ama-guides.ama-assn.org/",
      "children":[]
    },
    { "title":"GCEP",
      "url":"https://signin.curriculum.ama-assn.org/gcep",
      "children":[]
    }
  ],
  "footer":
    [
      {
        "title":"Column 1",
        "url":"#test",
        "children":[
          { "title":"Vacant Position Listings ",
            "url":"/vacant-position"
          },
          { "title":"Institution Directory",
            "url":"/institution"
          },
          { "title":"Explore Specialties",
            "url":"/specialty"
          }
        ]
      },
      {
        "title":"Column 2",
        "url":"route:<nolink>",
        "children":[
          { "title":"Video Gallery",
            "url":"/video-series"
          },
          { "title":"About FREIDA",
          },
          { "title":"Program Director Portal",
            "url":"/director"
          }
        ]
    },
    {
      "title":"Column 3",
      "url":"route:<nolink>",
      "children":[
        { "title":"Member Benefits",
          "url":"/memberbenefits"
        },
        { "title":"Contact FREIDA",
          "url":"/contact"
        },
        { "title":"FAQ",
          "url":"/faq"
        }
      ]
    }
  ]
};
